import React from "react";
import SqlScriptExecutorPanel from "./SqlScriptExecutorPanel";

export default function ThuriyamDashboard() {
    return (
        <div className="bg-white rounded-xl border border-gray-200 p-5 shadow-sm">
            <SqlScriptExecutorPanel />
        </div>
    );
}
